import FeatureAvailability_Services = require("VSS/FeatureAvailability/Services");
import ServerConstants = require("Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants");
import * as TCMLite from "TestManagement/Scripts/TFS.TestManagement.Lite";
import TFS_FeatureLicenseService = require("Presentation/Scripts/TFS/TFS.FeatureLicenseService");
import Utils_Core = require("VSS/Utils/Core");
import { getService } from "VSS/Service";
import { WebPageDataService } from "VSS/Contributions/Services";
import { DesktopTestRunHelper } from "TestManagement/Scripts/TFS.TestManagement.DesktopTestRunHelper";

export class LicenseAndFeatureFlagUtils {
    private static _featureEnabled: boolean = null;
    private static _advancedTestExtensionEnabled: boolean = null;

    public static AreAdvancedTestManagementFeaturesEnabled(): boolean {
        if (this._isAdvancedTestExtensionEnabled()) {
            return true;
        }

        let isFeatureActive = TFS_FeatureLicenseService.FeatureLicenseService.isFeatureActive(ServerConstants.LicenseFeatureIds.TestManagement);
        return isFeatureActive;
    }

    public static isQuickStartTraceabilityEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriQuickStartTraceability, false);
    }

    public static isTrendChartFeatureForRMEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriTrendChartsForRM, true);
    }

    public static isTriShowTestRunSummaryInContextEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriShowTestRunSummaryInContext, false);
    }

    public static isTestTabInNewWebPlatformEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementTestTabInNewWebPlatform, false);
    }

    public static isNewTestTabEnabledInOldBuild(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementTestTabExtensionBuild, false);
    }

    public static isEnableXtForEdgeFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTCMEnableXtForEdge, false);
    }

    public static isEnableDesktopScreenCaptureFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementEnableDesktopScreenShot , false);
    }

    public static isVideoWithAudioFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementEnableAudioWithVideo, false);
    }

    public static isReportCustomizationFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriReportCustomization, false);
    }

    public static isRenderMarkDownCommentEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementRenderMarkDownComment, false);
    }

    public static isUpdateRunCommentEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementUpdateRunComment, false);
    }

    public static isLogStoreAttachmentsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.LogStoreAttachments, false);
    }

    public static isGridViewOfRunsOrResultsAttachmentsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementAttachmentsGridView, false);
    }

    public static isGridViewOfAssociatedBugsToTestResultsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementBugsGridView, false);
    }

    public static isGridViewOfAssociatedWorkItemsToTestResultsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementLinkedItemsGridView, false);
    }

    public static isDirectQueryFromTcmServiceEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.QueryFromTcmService, false);
    }

    public static isGridViewOfLinkedRequirementsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementRequirementsGridView, false);
    }

    public static isNewOutcomeFiltersForRerunEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementFiltersForRerun, false);
    }

    public static isPointCountFeatureDisabled(): boolean{
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementPointCountFeatureDisabled, false);
    }

    public static isSingletonTestPointGridToolbarInstanceEnabled(): boolean{
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.IsSingletonTestPointGridToolbarInstanceEnabled, false);
    }

    public static isReactBasedRunWithOptionsEnabled(): boolean{
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementReactBasedRunWithOptionsDialog, false);
    }

    public static isAddToExistingBugInTestResultSummaryPageEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AddToExistingBugResultSummaryPage, false);
    }

    public static isQueryTestCaseRefInfoInWorkItemLinksIndependentlyEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementAddRefLinksToRequirement, false);
    }

    public static isTestResultsFilterInCICDEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriTestResultsSearchAndFilter, false);
    }

    public static isAnalyticsTestResultsFiltersEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AnalyticsTestResultsFilters, false);
    }

    public static isAnalyticsRouteAPIsToTestResultDailyEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AnalyticsRouteAPIsToTestResultDaily, false);
    }

    public static isAnalyticsSwitchToTestSKContextFilterEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AnalyticsSwitchToTestSKContextFilter, false);
    }

    public static isAnalyticsGroupByAndFilterOnTestSKEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AnalyticsGroupByAndFilterOnTestSK, false);
    }

    public static isAbortedRunsFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriReportingAbortedRuns, false);
    }

    public static isInProgressFeatureEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriInProgress, false);
    }

    public static isSummaryEnabledForAllNotImpactedTests(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementShowSummaryForNotImpactedTests, false);
    }

    public static isDesktopTestRunnerOptionEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessShowDTROptionForTestRunner, false);
    }

    public static isTriSignalRIntegrationEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.TriSignalRIntegration, false);
    }

    public static isPublishOnTCMServiceEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.PublishOnTcmService, false);
    }

    public static isHierarchicalViewForResultsEnabled(): boolean{
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementHierarchicalViewForResults, false);
    }

    public static isLinkedStackTraceEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementLinkedStackTrace, false);
    }

    public static isNewTestPlanHubExperienceEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementNewTestPlanExperienceToggle, false);
    }

    public static isMyTestPlanSkinnyProviderEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTCMMineTestPlanSkinnyProvider, false);
    }

    public static isAllTestPlanSkinnyProviderEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTCMAllTestPlanSkinnyProvider, false);
    }

    public static isAdvTestExtPermissionsProviderEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTCMAdvTestExtPermissionsProvider, false);
    }

    public static isUseOnlyLongPollingEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.UseOnlyLongPolling, false);
    }

    public static isFilterInInProgressEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.ShouldEnableFilterInInProgress, false);
    }

    public static isInProgressRunsInInProgressDefaultViewEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.WebAccessTestManagementInProgressRunsInInProgressDefaultView, false);
    }

    public static isLWPTestTabIsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.LWPTestTab, false);
    }

    public static isTestStepInLineImageCopyPasteEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(LicenseAndFeatureFlagUtils.TestStepInLineImageCopyPaste, false);
    }

    public static isUseLWPTestTabInReleaseIsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(LicenseAndFeatureFlagUtils.UseLWPTestTabInRelease, false);
    }

    public static isUseSeparateAppPoolForTcmSignalREnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(LicenseAndFeatureFlagUtils.UseSeparateAppPoolForTcmSignalR, false);
    }

    public static isAnalyticsHubForManualTestEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.AnalyticsHubForManualTest, false);
    }

    public static isDisableAutoRefreshOfEntryPointTextForAnalyticsHubForManualTestEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.DisableAutoRefreshOfEntryPointTextForAnalyticsHubForManualTest, false);
    }

    public static isShowDTRUpdateMsgLaunchDialogEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.ShowDTRUpdateMsgLaunchDialog, false);
    }
    
    public static isTestFlakinessEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(LicenseAndFeatureFlagUtils.EnableTestFlakiness, false);
    }

    public static isTestProjectSettingsEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(LicenseAndFeatureFlagUtils.EnableTestProjectSettings, false);
    }

    public static isGetTestFailureTypeFromTcmEnabled(): boolean {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(ServerConstants.FeatureAvailabilityFlags.EnableGetTestFailureTypeFromTcm, false);
    }


    private static _isAdvancedTestExtensionEnabled(): boolean {
        if (this._advancedTestExtensionEnabled === null) {
            let data = Utils_Core.parseJsonIsland($(document), ".__advancedTestExtensionEnabled");
            if (data) {
                this._advancedTestExtensionEnabled = data.advancedTestExtensionEnabled;
            } else {
                var response;

                // Added FF check to handle AT/DT scenario.
                if (LicenseAndFeatureFlagUtils.isAdvTestExtPermissionsProviderEnabled()) {
                    response = getService(WebPageDataService).getPageData<TCMLite.IJsonResponse>("ms.vss-test-web.testPlan-hub-advanced-test-extension-permissions-data-provider");
                } else {
                    response = getService(WebPageDataService).getPageData<TCMLite.IJsonResponse>("ms.vss-test-web.hub-testPlan-data-provider");
                }
                
                if (response) {
                    this._advancedTestExtensionEnabled = response.isAdvancedTestExtensionEnabled
                } else {
                    this._advancedTestExtensionEnabled = false;
                }
            }
        }

        return this._advancedTestExtensionEnabled;
    }

    private static readonly UseLWPTestTabInRelease = "WebAccess.TestManagement.UseLWPTestTabInRelease";
    private static readonly TestStepInLineImageCopyPaste = "WebAccess.TestManagement.TestStepInLineImageCopyPaste";
    private static readonly EnableTestFlakiness = "TestManagement.Server.EnableTestFlakiness";
    private static readonly EnableTestProjectSettings = "TestManagement.Server.ShowTestProjectSettings";
    private static readonly UseSeparateAppPoolForTcmSignalR = "TestManagement.SignalR.SeparateAppPool";
}